import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PointOfContact from './PointOfContact';
import ProfileCard from './ProfileCard';

export default function VendorInformation({ nextStep, ...rest }) {
  const { vendorRetailPayload } = useSelector((store) => store.vendorRetail);
  const [pointOfContactValues, setPointOfContactValues] = useState({
    contact_name: '',
    contact_email: '',
    contact_phone: '',
  });

  useEffect(() => {
    if (vendorRetailPayload) {
      setPointOfContactValues({
        contact_name: vendorRetailPayload.contact_name || '',
        contact_email: vendorRetailPayload.contact_email || '',
        contact_phone: vendorRetailPayload.contact_phone || '',
      });
    }
  }, [vendorRetailPayload]);

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <ProfileCard />
      </div>
      <div>
        <PointOfContact nextStep={nextStep} initialValues={pointOfContactValues} {...rest} />
      </div>
    </>
  );
}

VendorInformation.propTypes = {
  nextStep: PropTypes.func,
};

VendorInformation.defaultProps = {
  nextStep: () => {},
};
